import React from 'react';
import { I18n } from '@fiverr-private/i18n-react';
import { Typography } from '@fiverr-private/typography';

const TranslatedBadge: React.FC = () => (
  <Typography className="translated-badge" as="p" size="b_xs" color="grey_1000">
    <I18n k="gig_page_perseus.ugc.translated_by_amazon" />
  </Typography>
);

export default TranslatedBadge;
